import { InventoryItem } from './equipmentTypes';

export const getSlotName = (slot: string | undefined | null): string => {
  if (slot === undefined || slot === null) return 'Unknown';
  return slot;
};

export const getSlotEnumValue = (slot: string): number => {
  const slotMap: { [key: string]: number } = {
    mainHand: 0, offHand: 1, head: 2, chest: 3,
    legs: 4, feet: 5, hands: 6, necklace: 7,
    ring1: 8, ring2: 9, belt: 10, back: 11,
  };
  return slotMap[slot];
};

export const canEquipInSlot = (item: InventoryItem, targetSlot: string): boolean => {
  const slot = item.equipmentSlot;
  if (slot !== undefined && slot !== null) {
    // Backend returns string enum values like "MainHand", "OffHand", etc.
    const slotMap: { [key: string]: string[] } = {
      mainHand: ['MainHand'], offHand: ['OffHand'], head: ['Head'], chest: ['Chest'],
      legs: ['Legs'], feet: ['Feet'], hands: ['Hands'], necklace: ['Necklace'],
      ring1: ['Ring1', 'Ring2'], ring2: ['Ring1', 'Ring2'], belt: ['Belt'], back: ['Back'],
    };
    const allowedSlots = slotMap[targetSlot];
    if (!allowedSlots) return false;
    return allowedSlots.includes(slot);
  }

  // Fall back to legacy itemType string: "Weapon", "Armor", "Accessory"
  const itemType = item.itemType;
  const legacySlotMap: { [key: string]: string[] } = {
    mainHand: ['Weapon'], offHand: ['Weapon'], head: ['Armor'], chest: ['Armor'],
    legs: ['Armor'], feet: ['Armor'], hands: ['Armor'], necklace: ['Accessory'],
    ring1: ['Accessory'], ring2: ['Accessory'], belt: ['Accessory'], back: ['Accessory'],
  };
  const allowedTypes = legacySlotMap[targetSlot];
  if (!allowedTypes) return false;
  return allowedTypes.includes(itemType);
};
